import React from "react";
import logo from "../assets/img/logo.png";
import AuthService from "../Authentication/AuthService";

class UserExist extends React.Component {
  authService;
  constructor(props) {
    super(props);
    this.authService = new AuthService();
    this.state = {
    };
  }

  login = () => {
    this.props.history.push('/login');
  }

  render() {
    return (
      <div className="row">
        <div className="col-sm-12 col-md-12">
          <div className="app-header" style={{ borderBottom: "none" }}>
            <div className="site-header-inner my-1">
              <div className="row wid100 ml-0" style={{ maxWidth: '100%', flex: '0 0 100%' }}>
                <div className="col-sm-6 col-md-6">
                  <a href="#" style={{ padding: "0.5rem 1rem" }}>
                    <img className="logo-image" src={logo}></img>
                  </a>
                </div>
                <div className="col-sm-6 col-md-6 text-right">
                  <div className="mt-3 mx-2">
                    <button className="btn btn-primary my-2 my-sm-0" type="submit" onClick={() => this.logout()}>Logout</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="alert alert-danger mx-2 mt-3 pt-4">
		<strong>Error</strong>
		<div className="danger validation-summary-errors" data-valmsg-summary="true"><ul><li>User Not Exists</li>
</ul></div>
	</div>
                
    <div className="align-items-center p-3 px-md-4  bg-white border-bottom footerStyle" style={{ marginTop: '25%' }}>
        <div className="row">
            <div className="col-1"></div>
            <div className="col-6 col-md d-block mt-3 mb-3 text-muted">
                © Marine Mechanics
            </div>
        </div>
    </div>
        </div>
      </div>
    );
  }

  logout() {
    this.authService.logout();
}

}

export default UserExist;
